const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_authed/workspaces/$id/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { ApiCaller } from '@graphit/callers';
import { meQueryOptions } from '~/queries/me';
import { workspaceQueryOptions } from '~/queries/workspace';
export const Route = createFileRoute('/_authed/workspaces/$id')({
  loader: async ({
    context,
    params
  }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions);
    if (me.lastViewedWorkspaceId !== params.id) {
      context.queryClient.setQueryData(meQueryOptions.queryKey, {
        ...me,
        lastViewedWorkspaceId: params.id
      });
      void ApiCaller.setLastViewedWorkspace(params.id).catch(() => {});
    }
    return context.queryClient.ensureQueryData(workspaceQueryOptions(params.id));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface WorkspaceHeaderProps {
  workspaceId: string;
  workspaceName: string;
  isShared: boolean;
  openImportNodesModal: () => void;
}